var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 25,
    cy: 25,
    rx: 25,
    ry: 25,
    transform: "translate(0 0)",
    fill: "#004494"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M802.475,726.379H782.293a6.281,6.281,0,0,0-6.307,6.307v20.182a6.281,6.281,0,0,0,6.307,6.307h20.182a6.281,6.281,0,0,0,6.307-6.307V732.686A6.281,6.281,0,0,0,802.475,726.379Zm1.822,3.784h.7v5.606h-5.606v-5.606Zm-16.538,9.25a5.68,5.68,0,0,1,9.25,0,5.7,5.7,0,0,1,1.121,3.364,5.746,5.746,0,1,1-11.493,0A5.7,5.7,0,0,1,787.759,739.413Zm17.8,13.455a3.111,3.111,0,0,1-3.083,3.083H782.293a3.111,3.111,0,0,1-3.083-3.083V739.413h4.905a8.971,8.971,0,1,0,16.538,0h4.905Z",
    transform: "translate(-767.384 -717.777)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.43515697027cff016d7072b2e83c9bd7.svg";
export { ForwardRef as ReactComponent };